import kotlin.math.pow

inline fun jsObject(init: dynamic.() -> Unit): dynamic {
    val o = js("{}")
    init(o)
    return o
}

/**
 * Converts midicents to frequency
 * @param tuning Set to 440hz by default.
 */
fun Double.toFreq(tuning: Double = 440.0):Double {
    return 2.0.pow((this-69.0)/12.0) * tuning
}

/**
 * Converts midicents to frequency
 * @param tuning Set to 440hz by default.
 */
fun Int.toFreq(tuning: Double = 440.0):Double {
    return 2.0.pow((this-69.0)/12.0) * tuning
}



